
































import Vue from 'vue'
import Component, {mixins} from 'vue-class-component';
import {Tag} from '@/modules/blog/types';
import {Action, Mutation, State} from 'vuex-class';
import Loader from '@/components/Loader.vue';
import ConfirmDeleteTag from '@/modules/blog/components/tag/ConfirmDeleteTag.vue';
import TagDetail from '@/modules/blog/components/tag/TagDetail.vue';
import Authorizable from '@/modules/authorization/mixins/Authorizable';
import {DateMixin} from '@/modules/core/date';

/**
 * Lista de etiquetas
 *
 * @author Alejandro G. Riaño <agutierrez@soffcontrol.es>
 */
@Component({
    components: {TagDetail, ConfirmDeleteTag, Loader},
})
export default class TagList extends mixins(Authorizable, DateMixin)  {
    /**
     * Lista de etiquetas registradas en la aplicación
     *
     * @var { Tag[] }
     */
    @State(state => state.blog.tags)
    public tags: Tag[]

    /**
     * Carga la lista de etiquetas en el estado
     */
    @Action('blog/loadTags')
    public loadTags: () => Promise<void>

    /**
     * Establece la etiqueta actual en edición
     */
    @Mutation('blog/SET_CURRENT_TAG')
    public setCurrentTag: (tag: Tag) => void

    public loading = true
    public confirmDelete = false
    public tagDetail = false

    /**
     * Indica si el usuario actual tiene permiso para actualizar la información
     * de una etiqueta. Si no lo tiene no aparecerá el botón "Editar"
     * en la tarjeta del tag
     *
     * @return { boolean }
     */
    public get canUpdate (): boolean {
        return this.hasPermission('@/blog/admin/tags/update')
    }

    /**
     * Indica si el usuario actual tiene permiso para eliminar una etiqueta.
     * Si no lo tiene no aparecerá el botón "Eliminar" en la tarjeta del tag
     *
     * @return { boolean }
     */
    public get canDelete (): boolean {
        return this.hasPermission('@/blog/admin/tags/delete')
    }

    /**
     * Indica si el usuario actual tiene permiso para crear una etiqueta. Si no
     * lo tiene no aparecerá la barra de herramientas con el botón
     * "Añadir etiqueta"
     *
     * @return { boolean }
     */
    public get canCreate (): boolean {
        return this.hasPermission('@/blog/admin/tags/create')
    }

    /**
     * Activa el dialogo para que el usuario confirme la eliminación de un usuario
     */
    public activeDeleteDialog (tag: Tag) {
        this.confirmDelete = true
        this.setCurrentTag(tag)
    }

    /**
     * Método invocado cuando un usuario hace click sobre el botón "Editar" de una
     * etiqueta. Muestra la pantalla para modificar la información de esta.
     *
     * @param tag { Tag }
     */
    public activeTagDetail (tag: Tag) {
        this.tagDetail = true
        this.setCurrentTag(tag)
    }

    public async createTag () {
        await this.$store.dispatch('blog/createNewTag')
        this.tagDetail = true
    }

    /**
     * Al crear el componente solicita la carga de
     */
    public async created () {
        await this.loadTags()
        // Solicita a la aplicación que compruebe si el usuario posee los permisos para
        // crear, eliminar y actualizar etiquetas
        await this.authorize([
            '@/blog/admin/tags/delete',
            '@/blog/admin/tags/create',
            '@/blog/admin/tags/update',
        ])

        this.loading = false
    }
}
